import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useMount } from "react-use";
import { useStores } from "../hooks";
import { closeLED } from "../service";
import Header from "../component/Header";

const Logout = () => {
  const { sessionStore } = useStores();
  const [complete, setComplate] = useState(false);

  useMount(() => {
    if (sessionStore.isLogin) {
      // 有登入必須做 Redis Logout
      sessionStore.reset();
    } else {
      sessionStore.reset();
    }
    if (!sessionStore.debug) {
      closeLED();
    }
    setComplate(true);
  });

  return (
    <>
      {complete ? (
        <Navigate to="/" />
      ) : (
        <>
          <Header />
          <div className="content">
            <div className="book_detail">
              <h2 className="none-book">...</h2>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Logout;
